import { Transform } from 'class-transformer';
import { DateTransform } from '@/utils/value-transformers/date.transform';

export default class EngagementScoreModel {
  score!: number;

  totalInteractions!: number;

  @Transform(DateTransform)
  ultimaAtividade!: Date | null;
}
